import FaqContent from "page_components/client/faq/Content";
import FaqProvider from "context/client/faq";

const Faq = () => (
  <FaqProvider>
    <FaqContent />
  </FaqProvider>
);

export default Faq;
